import { COUNTRY_CODE_SUPPORT, LOCAL_STORAGE } from 'app/commons/constants'
import { isEmpty } from 'app/commons/helpers/compare'
import * as Utils from 'app/commons/helpers/utils'
import coreApi from 'app/services/coreApi'
import * as authAction from 'app/store/auth/authAction'
import { handleUpdateCustomerSetting } from 'app/store/config/configAction'
import { modalCreateActions } from 'app/store/modal/modalSlice'

import { PureComponent } from 'react'
import { Button } from 'react-bootstrap'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import _get from 'lodash.get'

import Popup from 'app/components/Common/Popup'

import { ARROW_UP_RIGHT, DEFAULT_AVATAR, ICON_DELIVEREE_GREEN } from '../../commons/constants/image.const'
import { MODAL_TYPES } from '../../commons/constants/modal.const'
import PopupModal from '../Common/PopupModal'
import './style.scss'

const popupItemsMaskPhone = {
  title: 'ar_sc_pn_td_title',
  content: 'ar_sc_pn_td_content',
}

class UserProfile extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      id: null,
      validAvatar: true,
      maskPhoneData: null,
      isOpenChangeAccount: false,
    }
  }

  chooseAccount = (id) => () => {
    authAction.handleSwitchAccount({
      id,
      callback: () => null,
    })
    this.setState({ isOpenChangeAccount: true })
  }

  renderBusinessAccounts = () => {
    const { accounts, businessAccounts } = this.props
    const businessAccountsList = !!businessAccounts?.length
      ? businessAccounts.map((acc) => ({
          ...acc,
          id: acc.id || acc.company_id,
          email: accounts.email,
          src: acc.company_id ? acc?.photo_url : acc?.avatar_square,
        }))
      : []
    const listAccounts = [
      {
        ...accounts,
        src: accounts.logo_url || accounts.avatar_square,
      },
      ...businessAccountsList,
    ]
    const companyId = Utils.getCompanyId(accounts)

    return listAccounts.map((v, i) => (
      <div
        className={`Box-List-Item ${
          (companyId && +companyId === +v.id) || (!companyId && +accounts.id === +v.id) ? 'active' : ''
        }`}
        key={i}
        onClick={this.chooseAccount(v.id)}
        role="presentation"
      >
        <div className="rounded Avatar__header">
          <img
            src={(v?.company_type_id ? v.photo_url : v.avatar_square) || DEFAULT_AVATAR}
            onError={(e) => {
              e.target.src = DEFAULT_AVATAR
            }}
            alt=""
          />
        </div>
        <div className="TitleSubtitle">
          <div className="TitleSubtitle-title">{v.name}</div>
          <div className="TitleSubtitle-subtitle">{v.email}</div>
        </div>
      </div>
    ))
  }

  handlePopupMaskPhone = async () => {
    const localAreaId = localStorage.getItem(LOCAL_STORAGE.AREA_ID) || 3
    try {
      const params = {
        area_id: localAreaId,
        popup_type: 'ar_sc_pn_td',
      }
      const response = await coreApi.getPopupArea(params)
      if (response && response.status === 200) {
        this.setState({ maskPhoneData: response.object, showMaskPhonePopup: true })
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  onChangeSettings = (checked, key) => {
    const { openModal, closeModal, t } = this.props
    const params = {
      [`settings[customer.${key}]`]: checked,
    }
    if (key === 'send_sms_to_recipients') {
      handleUpdateCustomerSetting({
        params,
        cb: () => {
          window.location.reload()
        },
      })
      return
    }
    openModal({
      typeModal: MODAL_TYPES.MODAL_CONFIRM,
      modalProps: {
        showClose: true,
        header: t('common.changeSetting'),
        content: t('common.contentForSingle'),
        cancel: {
          text: t('common.back'),
          action: closeModal,
        },
        confirm: {
          text: t('common.continue'),
          action: () => {
            handleUpdateCustomerSetting({
              params,
              cb: () => {
                window.location.reload()
              },
            })
          },
        },
      },
    })
  }

  getFormatContentArea = (popupData, objectType) => {
    if (popupData) {
      let content

      popupData.popup_items.forEach((item) => {
        if (item.item_type === objectType) {
          content = item.formated_content
        }
      })

      return content
    }

    return null
  }

  renderItemCard = ({ title, onClick }) => {
    return (
      <div className="Box-List-Item RightMenu-referral" onClick={onClick}>
        <div className="RightMenu-referral--code">{title}</div>
        <span>
          <img src={ARROW_UP_RIGHT} alt="icon-question" />
        </span>
      </div>
    )
  }

  renderContentTermsConditions = ({ extraInfos, currentCustomer, t }) => {
    const { tc_link, privacy_policy_link = '' } = extraInfos
    const companyId = currentCustomer.currentCompanyId
    const isBp = !!companyId
    let termsOfUseText = ''
    let dataPrivacyText = ''

    const handleClick = (link) => {
      window.open(link, '_blank')
    }

    switch (currentCustomer.country_code) {
      case COUNTRY_CODE_SUPPORT.PH:
        termsOfUseText = isBp
          ? t('common.userProfile.business_account_terms_of_use')
          : t('common.userProfile.ordinary_account_terms_of_use')
        dataPrivacyText = t('common.userProfile.data_privacy_policy')
        break
      case COUNTRY_CODE_SUPPORT.TH:
        termsOfUseText = t('common.userProfile.terms_of_use')
        dataPrivacyText = t('common.userProfile.data_privacy_policy')
        break
      default:
        termsOfUseText = t('common.userProfile.terms_of_use')
        dataPrivacyText = t('common.userProfile.data_privacy_and_security')
        break
    }

    return (
      <>
        {this.renderItemCard({
          title: termsOfUseText,
          onClick: () => handleClick(isBp ? tc_link?.bp : tc_link?.non_bp),
        })}
        {this.renderItemCard({ title: dataPrivacyText, onClick: () => handleClick(privacy_policy_link) })}
      </>
    )
  }

  render() {
    const { accounts, t, closeModal, openModal, config } = this.props
    const { maskPhoneData, showMaskPhonePopup, isOpenChangeAccount } = this.state
    const referenceCode = _get(accounts, 'referral_code')
    const companyId = Utils.getCompanyId(accounts)
    const company = Utils.getCompanyAccount(companyId, accounts) || {}

    return (
      <div className="RightMenu visible">
        {accounts ? (
          <>
            <div className="RightMenu-Box">
              <div
                onClick={() => {
                  closeModal()
                }}
                className="Box-Head-Close"
                role="presentation"
              >
                <i className="material-icons">close</i>
              </div>
              <div className="Box-Head">
                <div className="RightMenu-avatar-block">
                  <div className="rounded Avatar">
                    <img
                      alt={company.name}
                      onError={(e) => {
                        e.target.src = DEFAULT_AVATAR
                      }}
                      src={(companyId ? company.photo_url : accounts.avatar_square) || DEFAULT_AVATAR}
                    />
                  </div>
                  <div className="TitleSubtitle">
                    <div className="TitleSubtitle-title">{companyId ? company.name : accounts.name}</div>
                    {accounts.email && <div className="TitleSubtitle-subtitle__mail">{accounts.email}</div>}
                  </div>
                  <div className="RightMenu-actions">
                    <button
                      type="button"
                      className="Button RightMenu-actions--edit"
                      onClick={() => openModal({ typeModal: MODAL_TYPES.USER_EDIT_PROFILE })}
                    >
                      {t('common.userProfile.editProfile')}
                    </button>
                  </div>
                </div>
              </div>
              <div className="Box-Content overflow-y-auto">
                <div className="Box-List">
                  <div className="RightMenu-Block RightMenu-account">
                    <div className="RightMenu-title">{t('common.userProfile.accounts')}</div>
                    <div>{!isEmpty(accounts?.accounts) ? this.renderBusinessAccounts() : null}</div>
                  </div>
                  <div className="RightMenu-Block RightMenu-manage--booking">
                    <div className="RightMenu-title"> {t('common.userProfile.freeSms')}</div>
                    <div className="Box-List-Item" id="share-eta-content">
                      <div className="flex-grow-1">{t('common.userProfile.recipientsReceiveFree')}</div>
                      <span>
                        <div className="Overlay-Checkbox Green-Checkbox">
                          <input
                            type="checkbox"
                            name="settings_value"
                            id="settings_value"
                            value={accounts.send_sms_to_recipients}
                            defaultChecked={accounts.send_sms_to_recipients}
                            onChange={(e) => this.onChangeSettings(e.target.checked, 'send_sms_to_recipients')}
                          />
                          <span className="Checkbox">
                            <span />
                          </span>
                        </div>
                      </span>
                    </div>
                    <div className="RightMenu-title"> {t('common.userProfile.referralCode')}</div>
                    <div className="Box-List-Item RightMenu-referral">
                      <div className="RightMenu-referral--code">{t('common.userProfile.uniqueCode')}</div>
                      <span>{referenceCode}</span>
                    </div>
                    <div className="RightMenu-title">{t('common.userProfile.option')}</div>
                    <div className="Box-List-Item RightMenu__show-phone">
                      <div className="flex-grow-1 show-phone__text">
                        {t('common.userProfile.showYourPhone')}
                        <span>
                          <i className="b material-icons Icon" onClick={() => this.handlePopupMaskPhone()}>
                            visibility
                          </i>
                        </span>
                      </div>
                      <span>
                        <div className="Overlay-Checkbox Green-Checkbox">
                          <input
                            type="checkbox"
                            name="settings_value"
                            id="settings_value"
                            value={accounts.show_phone_number_to_driver}
                            defaultChecked={accounts.show_phone_number_to_driver}
                            onChange={(e) => this.onChangeSettings(e.target.checked, 'show_phone_number_to_driver')}
                          />
                          <span className="Checkbox">
                            <span />
                          </span>
                        </div>
                      </span>
                    </div>
                    <div className="RightMenu-title">{t('common.userProfile.terms_and_conditions')}</div>
                    {this.renderContentTermsConditions({ extraInfos: config.data, currentCustomer: accounts, t })}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="RightMenu-close-pane"
              onClick={() => {
                closeModal()
              }}
            />
          </>
        ) : null}
        <Popup
          show={showMaskPhonePopup}
          title={
            maskPhoneData ? (
              <div className="Normal-Booking-Title">
                {this.getFormatContentArea(maskPhoneData, popupItemsMaskPhone.title)}
              </div>
            ) : null
          }
          specialFormatTitle
          iconUrl={maskPhoneData ? maskPhoneData.icon : null}
          onClose={() => this.setState({ showMaskPhonePopup: false })}
          showActions={false}
          modalClass="popup__mask-phone"
        >
          <div className="Normal-Booking-Devide" />
          <p
            className="center fullday"
            dangerouslySetInnerHTML={{
              __html: this.getFormatContentArea(maskPhoneData, popupItemsMaskPhone.content),
            }}
          />
        </Popup>
        <PopupModal
          closeButton={false}
          className="cool-modal popup-switch-account"
          modalSize="md"
          isOpen={isOpenChangeAccount}
          setIsOpen={() => this.setState({ isOpenChangeAccount: !isOpenChangeAccount })}
          headerIcon={ICON_DELIVEREE_GREEN}
          isCloseOutside={false}
        >
          <div className="wrap-content">
            <p>{t('common.confirmSwitchAccount')}</p>
          </div>
          <div className="wrap-button">
            <Button
              onClick={() => {
                window.onbeforeunload = null
                window.location.href = '/'
              }}
              type="button"
              variant="success"
              className="dark-green"
            >
              {t('common.ok')}
            </Button>
          </div>
        </PopupModal>
      </div>
    )
  }
}

const mapState = (state) => ({
  accounts: state.auth.login.accounts,
  businessAccounts: _get(state, 'configuration.data.joined_companies', []),
  config: state.configuration,
})

const actions = {
  ...modalCreateActions,
  ...authAction,
}

export default withRouter(connect(mapState, actions)(withTranslation()(UserProfile)))
